import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';

import DefaultConfig from './defaultConfig';
import DefaultFlavor from './defaultFlavor';
import ExpandJsonView from './expand-json-view';
import { Divider } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import AppActions from '../../actions/app-actions';
import { preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
    minWidth: '50em'
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});

//TODO MP: This will be fetched from Backend when ready, hardcoding for now.
const types = [
  {
    value: 'VMS',
    label: 'VMS'
  },
  {
    value: 'VSAAS',
    label: 'VSAAS'
  }
];

const configOptions = [
  {
    value: 'configs',
    label: 'CONFIG'
  },
  {
    value: 'flavors',
    label: 'FLAVOR'
  }
];

// Below objects shall be added for new config/flavor creation
const defaultConfigObj = {
  label: 'DEFAULT',
  value: 'default',
  config: DefaultConfig
}
const defaultFlavorObj = {
  label: 'DEFAULT',
  value: 'default',
  config: DefaultFlavor
}
const emptyObj = {
  label: 'EMPTY',
  value: 'empty',
  config: {}
}

class ConfigDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
  }

  componentDidMount() {
    //this._getConfigListByType('configs');
  }

  _getInitialState = () => {
    return {
      fullWidth: true,
      maxWidth: 'lg',
      open: (this.props.open || false),
      edit: (this.props.edit || false),
      type: (this.props.type || 'configs'),
      config: (this.props.config || {}),
      selectedConfigOption: (this.props.type !== 'all'? this.props.type : null),
      selectedName: '',
      selectedType: null,
      selectedConfig: null,
      configDetails: (this.props.edit ? this._getConfigDetails() : {}),
      configList: [],
      currentUserRole: getUserRoleFromJWT(),
    };
  }

  _getConfigDetails = () => {
    var cfgDetails =  (this.props.type === 'configs') ? this.props.config.config_details : this.props.config.container;
    return (Object.keys(cfgDetails).length === 0) ? {} : JSON.parse(cfgDetails);
  }
  addDefaultConfigs = () => {
    var configNames = [];
    //Add default and empty options to the config list
    var type = (this.state.selectedConfigOption || 'configs');
    (type === 'flavors') ? configNames.push(defaultFlavorObj) : configNames.push(defaultConfigObj);
    configNames.push(emptyObj);
    return configNames;
  }

  handleClickOpen = () => {
    this.setState(this._getInitialState());
    this.setState({ open: true });
  };

  handleSubmit = () => {
    var newConfig = {};
    var conType = (this.props.type === 'all') ? this.state.selectedConfigOption : this.props.type;
    //PM TODO: Modify config structure before sending it for saving
    // type, name, config_details - try to match as per schema

    //Handle Edit
    if (this.props.edit) {
      //Deep cloning
      newConfig = JSON.parse(JSON.stringify(this.state.config));
      if (conType === 'configs') {
        newConfig['config_details'] = JSON.stringify(this.state.configDetails);
      } else if (conType === 'flavors') {
        newConfig['container'] = JSON.stringify(this.state.configDetails);
      }
    } else {
      //Handle Create
      newConfig['type'] = this.state.selectedType;
      if (conType === 'configs') {
        newConfig['name'] = this.state.selectedName;
        newConfig['config_details'] = JSON.stringify(this.state.configDetails);
      } else if (conType === 'flavors') {
        newConfig['name'] = this.state.selectedName;
        newConfig['container'] = JSON.stringify(this.state.configDetails);
      }
    }
    if(this.props.handleSubmit) {
      this.props.handleSubmit(newConfig);
    }
    this.setState({ open: false });
  };

  handleCancel = () => {
    this.setState({ open: false });
    if(this.props.handleCancel) {
      this.props.handleCancel();
    }
  };

  // Handle VMS (VSAAS) change, update list of configs/flavors that belong to VMS (VSAAS).
  handleTypeChange = (event) => {
    let selectedType = event.target.value;
    let configList = this.addDefaultConfigs();
    if (this.state.selectedType !== selectedType) {
      this.setState({selectedType : selectedType, configList : configList});
      this._getConfigListByType(this.state.selectedConfigOption, selectedType);
    }
  }

  // Applicable only when launched from Configurations -> ALL menu.
  // Provides option to create either config or flavor
  handleConfigOptionChange = (event) => {
    this.setState({selectedConfigOption:event.target.value});
    let configList = this.addDefaultConfigs();
    this.setState({configList:configList});
  }

  handleNameChange = (event) => {
    this.setState({selectedName : event.target.value});
  };

  // Handle Configuration chosen from the given list
  handleConfigChange = name => event => {
    var configDetails;
    var configName = (name === 'selectedConfig') ? event.target.value : '';
    var config = this._getConfig(configName);
    this.setState({ selectedConfig : configName });
    //Config from backend is a string, so convert it to object
    if (configName !== 'empty' && configName !== 'default') {
      configDetails = JSON.parse(config.config_details || config.container) || {};
    } else {
      configDetails = (config.config_details || config.container || {});
    }
    this.setState({configDetails : configDetails});
  };

  // Handle edited configuration from JSON viewer
  handleEdit = (e) => {
    console.log('handleEdit : ', e.updated_src);
    //PM TODO: Validate if something has changed, only then change state
    this.setState({ configDetails: e.updated_src }, () => {
      console.log(this.state.configDetails);
    });
  }

  //Get the actual config data from config name
  _getConfig = (name) => {
    let i;
    let configList = this.state.configList;
    for (i = 0; i < configList.length; i++) {
      if (configList[i].value === name) {
        return configList[i].config;
      }
    }
  }

  // Arguments: configs or flavors, VMS or VSAAS
  _getConfigListByType(configOption, configType) {
    var self = this;
    var callback = {
      success: function(configs) {
        var configList = self.state.configList;
        configs.map(config => {
          var configNameObj = {};
          configNameObj['value'] = config.name;
          configNameObj['label'] = config.name;
          configNameObj['config'] = config;
          configList.push(configNameObj);
          return configNameObj;
        });
        self.setState({ configList: configList });
      },
      error: function(err) {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'Configurations couldnot be loaded. ' + errormsg
          )
        );
      }
    };

    AppActions.getConfigurationsByType(
      configOption,
      configType,
      callback
    );
  }

  render() {
    const { classes } = this.props;
    var chooseFrom = this.state.configList;
    let titleLabel;
    let isNameValid = this.state.selectedName !== '';
    let isTypeChosen = this.state.selectedType != null;
    let isConfigChosen = this.state.selectedConfig !== null;

    if (this.props.edit) {
      //PM TODO: have common variables between config & flavor, eg. name, type, etc.,
      titleLabel = 'Edit ' + (this.props.config.name || '');
    } else {
      titleLabel = 'Create ' + (this.props.type !== 'all' ? (this.props.type === 'configs' ? 'Config' : 'Flavor') : '');
    }

    return (
      <React.Fragment>
        {this.props.edit ? null: (
          <Button
            className="top-right-button"
            color="secondary"
            variant="contained"
            disabled={this.state.currentUserRole !== 'admin'}
            style={{ position: 'absolute' }}
            onClick={this.handleClickOpen}
          >
            {this.props.buttonLabel ? this.props.buttonLabel : 'Create' }
          </Button>
        )}
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          aria-labelledby="config-dialog"
        >
          <DialogTitle id="config-dialog">{titleLabel}</DialogTitle>
          <DialogContent>
            <Divider />
            <form className={classes.form} noValidate>
              {this.props.edit ? null: (
                <FormControl className={classes.formControl}>
                  <TextField
                    required
                    id="standard-required"
                    label="Choose a Name"
                    defaultValue=""
                    className={classes.textField}
                    margin="normal"
                    value={this.state.selectedName}
                    onChange={this.handleNameChange}
                  />
                  {this.props.type !== 'all' ? null: (
                    <TextField
                      id="select"
                      disabled={!isNameValid}
                      select
                      label="Config or Flavor"
                      className={classes.textField}
                      value={this.state.selectedConfigOption || ''}
                      onChange={this.handleConfigOptionChange}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {configOptions.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}

                  <TextField
                    id="type-select"
                    disabled={!isNameValid}
                    select
                    label="Choose a Type"
                    className={classes.textField}
                    value={this.state.selectedType || ''}
                    onChange={this.handleTypeChange}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="normal"
                  >
                    {types.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    id="from-select"
                    disabled={!isTypeChosen}
                    select
                    label="Clone From (default, empty or other)"
                    className={classes.textField}
                    value={this.state.selectedConfig || ''}
                    onChange={this.handleConfigChange('selectedConfig')}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="normal"
                  >
                    {chooseFrom.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              )}
              <Divider />
              <br />
              <ExpandJsonView
                config={this.state.configDetails || {}}
                onAdd={this.handleEdit.bind(this)}
                onEdit={this.handleEdit.bind(this)}
                onDelete={this.handleEdit.bind(this)}
                name={null}
                enableClipboard={false}
              />
            </form>
          </DialogContent>
          <br />
          <Divider />
          <DialogActions>
            <Button
              onClick={this.handleCancel}
              style={{backgroundColor: 'lightgrey', padding: '6px 16px'}}
            >
              Cancel
            </Button>
            <Button disabled={!(this.props.edit || (isNameValid && isConfigChosen)) || this.state.currentUserRole !== 'admin'} onClick={this.handleSubmit} color="secondary" variant="contained">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

ConfigDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfigDialog);
